export enum Civility {
  MONSIEUR = 'MONSIEUR',
  MADAME = 'MADAME',
}

export enum AccountType {
  INDIVIDUAL = 'INDIVIDUAL',
  JOINT = 'DUO',
}

export enum Country {
  DEFAULT = 'FR',
  OTHER = 'AUTRE',
}

export type FormInput = Partial<{
  lastName: string
  firstName: string
  civility: string
  accountType: string
  birthDate: string
  country: string
  postalCode: string
  tel: string
  email: string
}>
